<template>
  <div :class="['logs', extraClasses]">
    <div class="logs__header sub-header">{{header}}</div>
    <loading-icon v-if="isLoading"></loading-icon>
    <div class="logs__list" role="list">
      <template v-if="!isLoading && logList">
        <div
            v-for="(log, index) in logList"
            class="logs__item"
            :key="log.retailer_campaign_id || index"
            role="listitem">
          <template v-if="isRetailersLog && currentAdvertiser.admin">
            <a :href="buildUrl(log.retailer)" class="logs__pointer-link">{{log.retailer}} </a>
            <span>{{buildLogText(log)}}</span>
          </template>
          <span v-else>{{log.retailer}} {{buildLogText(log)}}</span>
          <a
              v-if="isRetailersLog"
              href="#" class="logs__link"
              :title="`view ${log.retailer} campaign id ${log.retailer_campaign_id} details`"
              @click.prevent="$emit('setSelectedLogToView', log.retailer_campaign_id)">
            view
          </a>
        </div>
      </template>
      <small v-if="emptyText" :class="['logs__empty-text', {error: errorMessage}]">{{emptyText}}</small>
    </div>
  </div>
</template>

<script>
  import LoadingIcon from '../Shared/LoadingIcon'
  import LogDateFormat from '../mixins/LogDateFormat'
  import config from '../../config'

  export default {
    props: {
      currentAdvertiser: Object,
      apiParams: Object,
      extraClasses: String,
      availableRetailers: Array,
      header: String,
      logType: String,
      shouldReturnLogData: Boolean,
      url: String,
    },

    name: 'PerformanceLog',

    components: {
      LoadingIcon
    },

    mixins: [LogDateFormat],

    data() {
      return {
        errorMessage: null,
        isLoading: true,
        logList: null,
      }
    },

    computed: {
      emptyText: function() {
        return this.logList && this.logList.length === 0 ? `no ${this.logType} logs available` : this.errorMessage
      },

      isRetailersLog: function() {
        return this.logType === 'retailers'
      }
    },

    methods: {
      buildLogText(log) {
        if (this.logType === 'visitors') { return `purchase @ ${log.retailer} - ${this.formatLogDate(log.purchase_time)}` }
        if (this.isRetailersLog) {
          const isSent = !!log.sent_time,
              action = isSent ? 'sent' : 'scheduled',
              time = isSent ? log.sent_time : log.scheduled_for
          return `${action} - ${this.formatLogDate(time)}`
        }
      },

      configureLogList(data, error) {
        let errorText = `there was an error loading the ${this.logType} log`
        if (data && typeof data !== 'string') {
          this.logList = data
          this.errorMessage = null
        } else {
          this.logList = null
          this.errorMessage = error ? `${errorText}: ${error}` : errorText
        }
        this.shouldReturnLogData && this.$emit('setLog', this.logList, this.logType)
        this.isLoading = false
      },

      loadLog() {
        this.$api.get(this.url, this.apiParams)
          .then((response) => {
            this.configureLogList(response.data, null)
          })
          .catch((error) => {
            this.configureLogList(null, error)
          })
      },

      buildUrl(logRetailer) {
        const retailer = this.availableRetailers?.find(retailer => retailer.name === logRetailer)
        return retailer ? `${config.redirectUrl}/admin/merchants/${retailer.id}/login_as` : ''
      }
    },

    created() {
      this.loadLog()
    },

    watch: {
      apiParams: function() {
        this.loadLog()
      },
    },
  }
</script>

<style lang="sass">
  @import '../../assets/sass/colors'
  .logs
    flex: 1

    &__pointer-link
      color: $primary-color
      &:hover
        color: #4a4a4a
        cursor: pointer

    &__empty-text
      color: $negative-color
      font-size: 0.85em
      padding: 1em

      &.error
        color: $negative-hover
        font-size: 0.75em

    &__header
      color: black
      font-size: .85rem
      font-weight: bold
      margin-bottom: .25rem

    &__list
      border-right: 1px solid $primary-transparent
      height: 100%
      max-height: 75px
      overflow: scroll
      padding: 0 1rem

    &__item
      font-size: .95rem
      line-height: 110%
      padding: .15rem 0

    &__link
      color: $primary-color

      &:hover
        color: $title-color

    .loading-icon
      margin: 1rem auto
      width: 25px

</style>
